import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { FilteredEbsResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { attachmentsColumnDefs } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/attachmentsColumnDefs";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const ebsColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Volume-id", "volume_id"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("ebs"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Launch time"),

  getResourceSizeColumnDef(),

  { field: "resource.type", headerName: "Type" },

  attachmentsColumnDefs,

  {
    field: "resource.is_encrypted",
    headerName: "Encryption",
    valueGetter: ({ data }) => {
      return data?.resource?.is_encrypted ? "Encrypted" : "Unencrypted";
    },
    cellRenderer: ({ data }: ICellRendererParams<FilteredEbsResourceItem>) => {
      return data?.resource?.is_encrypted ? "Encrypted" : "Unencrypted";
    },
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
